module.exports = "/assets/data/509f008e39fb1bb6d563e779a65b7447-IV21.data.json";